<form [formGroup]="form" class="style-form">
     <div class="divSelector">
         <p class="inputRadio">Autorizar</p>
        <mat-radio-group class="checleft" formControlName="autorizar" aria-label="Select an option">
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
          </mat-radio-group>
     </div>
     <div class="divSelector">
        <p class="inputRadio">Patron de Fraude</p>
       <mat-radio-group class="checleft" formControlName="patronFraude" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
</form>
